<template>
  <modal>
    <div class="modal-form">
      <div class="modal-form-header">{{ title }}</div>
      <div class="modal-form-main">
        <div class="modal-form-description">
          {{ description }}
        </div>
        <div class="modal-form-buttons">
          <button @click.prevent.stop="onOk" class="btn-outline">
            {{ okLabel }}
          </button>
          <button @click.prevent.stop="onCancel" class="btn-outline">
            {{ cancelLabel }}
          </button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script lang="ts">
import Modal from "./Modal.vue";
import { Options, Vue } from "vue-class-component";

@Options({
  components: {
    Modal,
  },
  emits: ["ok", "click"],
  props: {
    title: {
      type: String,
      default: "Confirm",
    },
    description: {
      type: String,
      default: "Are you sure?",
    },
    okLabel: {
      type: String,
      default: "Ok",
    },
    cancelLabel: {
      type: String,
      default: "Cancel",
    },
  },
})
export default class Confirm extends Vue {
  title!: string;
  description!: string;
  okLabel!: string;
  cancelLabel!: string;

  onOk() {
    this.$emit("click");
    this.$emit("ok");
  }
  onCancel() {
    this.$emit("click");
    this.$emit("cancel");
  }

  mounted() {
    this.$emit("open");
  }
}
</script>

<style lang="scss">
.modal-form {
  width: 300px;
  margin: auto;
  background: white;
  border: 1px solid #999;
  border-radius: 3px;

  input.input {
    background-color: white;
  }
  .modal-form-header {
    padding: 4px;
    background: linear-gradient(180deg, #f0f0f0 0%, #d0d0d0 100%);
  }
  .modal-form-main {
    padding: 12px;
  }
  .modal-form-description {
    margin: 20px 0;
    text-align: center;
  }
  .modal-form-buttons {
    text-align: right;
    padding: 8px 8px;
  }
}
</style>
